import React, { Suspense, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginCheck } from '../_actions/userActions';
import NavBar from '../components/NavBar/NavBar';
import Footer from '../components/Footer/Footer';
import LandingPage from '../components/LandingPage/LandingPage';
import LoginPage from '../components/LoginPage/LoginPage';
import DetailPage from '../components/DetailPage/DetailPage';
import EditPage from '../components/EditPage/EditPage';
import CartPage from '../components/CartPage/CartPage';

function App() {
  const dispatch = useDispatch();
  const logined = localStorage.getItem('u_id');

  useEffect(() => {
    if (logined) {
      dispatch(loginCheck());
    }
  }, [logined]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NavBar />
      <div style={{ paddingTop: '69px', minHeight: 'calc(100vh - 80px)' }}>
        <Switch>
          <Route exact path='/' component={LandingPage} />
          <Route exact path='/login' component={LoginPage} />
          <Route exact path='/zzal/:zzalId' component={DetailPage} />
          <Route exact path='/edit/:zzalId' component={EditPage} />
          <Route exact path='/cart' component={CartPage} />
        </Switch>
      </div>
      <Footer />
    </Suspense>
  );
}

export default App;
